import { type FC } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';

import { IphoneSharedAppStoreLink } from '../IphoneSharedAppStoreLink/IphoneSharedAppStoreLink';
import { IphoneSharedLinkTextingWidget } from '../IphoneSharedLinkTextingWidget/IphoneSharedLinkTextingWidget';
import copy from '../helpers/copy';

import styles from './IphoneMobileLayout.scss';

export const IphoneMobileLayout: FC = () => {
    const intl = useIntl();

    return (
        <>
            <img
                className={styles.iphonesImg}
                src="//a.1stdibscdn.com/dist/adhoc/iphones.png?height=520"
                alt={intl.formatMessage(copy.iPhonesImg)}
            />

            <h1 className={styles.h1}>
                <FormattedMessage
                    id="IphoneMobileLayout.h1"
                    defaultMessage="The world’s {italic} are right at your fingertips"
                    values={{
                        italic: (
                            <span className={styles.h1Italic}>
                                <FormattedMessage
                                    id="IphoneMobileLayout.h1Italic"
                                    defaultMessage="most beautiful things"
                                />
                            </span>
                        ),
                    }}
                />
            </h1>

            <IphoneSharedAppStoreLink className={styles.appStoreLink} />

            <div className={styles.dowloadHeading}>
                <FormattedMessage
                    id="IphoneMobileLayout.downloadHeading"
                    defaultMessage="Get a link to download the 1stDibs app"
                />
            </div>

            <IphoneSharedLinkTextingWidget
                widgetClassNames={{
                    inputWrapper: styles.widgetInputWrapper,
                    button: styles.widgetButton,
                }}
            />

            <div className={styles.descriptionHeader}>{copy.descriptionHeader}</div>
            <div className={styles.description}>{copy.description}</div>
        </>
    );
};
